import axios from 'axios';

import config from '../../config';
import { EMAILS, MS_RECIPIENTS } from '../../constants';
import { User, SGEmailData } from '../../types';

import { getApiKeyClient, getBffClient } from '../client/http';

const {
  apiBaseUrl: {
    elements: elementsBaseUrl,
    auth: authBaseUrl,
    bffApi: bffBaseUrl,
  },
  localFeatureToggles: { turnOffEmails },
} = config;

const elementsApiKeyClient = () => getApiKeyClient(elementsBaseUrl);
const authApiKeyClient = () => getApiKeyClient(authBaseUrl);

export const sendEmail = async (emailData: SGEmailData) => {
  if (turnOffEmails) {
    console.log(
      'note: normally an email would be sent here, but it’s disabled in local',
      emailData,
    );
    return true;
  }

  try {
    const response = await elementsApiKeyClient().post('api/emails', emailData);
    return response.data.isSuccess;
  } catch (err: any) {
    throw new Error(`Error sending email: ${err.message}`);
  }
};

export const sendMsNotification = async (
  eventId: string,
  text?: string,
  addRecipients?: string[],
) => {
  let oneEmailSent = false;

  const recipientList = addRecipients
    ? MS_RECIPIENTS.concat(addRecipients)
    : MS_RECIPIENTS;

  await Promise.all(
    recipientList.map(async (recipient) => {
      const emailData = {
        recipientEmail: recipient,
        templateId: EMAILS.MS_NOTIFICATION,
        dynamicTemplateData: { event_name: eventId, text },
      };

      const isSuccess = await sendEmail(emailData);

      // at least one email is sent successfully
      if (isSuccess) oneEmailSent = true;
    }),
  );

  return oneEmailSent;
};

export const sendMsConfirmation = async (
  email: string,
  eventId: string,
  share_url: string,
) => {
  if (!email) return true;

  const emailData = {
    recipientEmail: email,
    templateId: EMAILS.MS_CONFIRMATION,
    dynamicTemplateData: { event_name: eventId, share_url },
  };

  const isSuccess = await sendEmail(emailData);

  return isSuccess;
};

export const sendUserVerification = async (email: string) => {
  try {
    const emailData = { email, baseUrl: window.location.origin };

    const response = await authApiKeyClient().post(
      'api/user/send-verification',
      emailData,
    );

    return response.data.isSuccess;
  } catch (err: any) {
    throw new Error(`Error sending user verification email: ${err.message}`);
  }
};

export const sendResetPassword = async (email: string) => {
  try {
    const emailData = { email, baseUrl: window.location.origin };

    const response = await authApiKeyClient().post(
      `api/user/forgot-password`,
      emailData,
    );

    return response.data.isSuccess;
  } catch (err: any) {
    throw new Error(`Error sending reset password email: ${err.message}`);
  }
};

export const subscribeContact = async (listId: string, user: User) => {
  try {
    await axios.post(
      `${bffBaseUrl}/api/sendgrid/subscribe?listId=${listId}&email=${user.email}&firstName=${user.firstName}&lastName=${user.lastName}`,
    );
  } catch (err: any) {
    throw new Error(`Error subscribing contact: ${err.message}`);
  }
};

export const getTemplate = async (templateId: string) => {
  try {
    const response = await getBffClient().post(
      `/api/sendgrid/getTemplate?templateId=${templateId}`,
    );
    return response.data.template;
  } catch (err: any) {
    throw new Error(`Error fetching SendGrid template: ${err.message}`);
  }
};

export const getFooter = async () => {
  try {
    const response = await getBffClient().post('/api/sendgrid/getFooter');
    return response.data.footer;
  } catch (err: any) {
    throw new Error(`Error fetching SendGrid footer: ${err.message}`);
  }
};
